"use client"

import {
  type ButtonHTMLAttributes,
  type MouseEvent,
  type ReactNode,
  useCallback
} from "react"

import useAnalytics from "@/hooks/useAnalytics"

interface TrackedButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  action?: string
  category: string
  children?: ReactNode
  label?: string
  value?: string
}

export default function TrackedButton({
  action = "Button Clicked",
  category,
  children,
  label,
  onClick,
  value,
  ...rest
}: TrackedButtonProps) {
  const { trackEvent } = useAnalytics()

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      // Call the original onClick handler first
      onClick?.(e)

      // Get the actual text content from the clicked button
      const textContent = e.currentTarget.textContent?.trim() || ""

      void trackEvent({
        action,
        category,
        label: label || textContent || "Button",
        value: value || textContent || "Button"
      })
    },
    [action, category, label, value, trackEvent, onClick]
  )

  return (
    <button {...rest} onClick={handleClick}>
      {children}
    </button>
  )
}
